"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardItemVisualization = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var DashboardItemBase_1 = require("./DashboardItemBase");
exports.DashboardItemVisualization = function (_a) {
    var visualizationClassName = _a.visualizationClassName, props = tslib_1.__rest(_a, ["visualizationClassName"]);
    return (react_1.default.createElement(DashboardItemBase_1.DashboardItemBase, tslib_1.__assign({}, props, { visualizationClassName: classnames_1.default("visualization", visualizationClassName) })));
};
//# sourceMappingURL=DashboardItemVisualization.js.map